import jwtDecode from "jwt-decode";
import Cookies from "universal-cookie";
import { z } from "zod";

import { BillSplitSchema } from "./BillSplit/schema";
import { CartSchema } from "./Cart/schema";
import { CustomerSchema } from "./Customer/schema";
import { CustomerTabSchema } from "./CustomerTab/schema";

const OrderCartJWT = z.object({
  exp: z.number(),
  resources: z.object({
    customer_tabs: z.array(z.string()),
    current_venue_uuid: z.string().optional(),
  }),
  role: z.literal("OrderCartClient"),
});

const JWTSchema = OrderCartJWT;
type JWT = z.infer<typeof JWTSchema>;
export function getJWTToken(): JWT | null {
  const cookies = new Cookies();
  const token = jwtDecode(cookies.get("token"));

  try {
    const parsedToken = JWTSchema.parse(token);

    console.log("Parsed JWT token", token, parsedToken);
    return parsedToken;
  } catch (e) {
    console.error("Error parsing JWT token", e);
    return null;
  }
}

export const SomeSessionSchema = z.object({
  customerTab: CustomerTabSchema.nullish(),
  cart: CartSchema,
  paymentMethod: z.string().nullish(),
  pastCustomerTabIds: z.array(CustomerTabSchema),
  pastCartIds: z.array(CustomerTabSchema),
});

export type Session = z.infer<typeof SomeSessionSchema>;
